@if (_subSection) {
  @if (_subSection.title) {
    <div class="mb-2 subsection-title title">
      {{ _subSection.title }}
    </div>
  }
  @if (!textEmpty) {
    <div class="subsection inner-html-quill" [innerHTML]="_subSection.content"></div>
  }
}
